export default {
  data() {
    return {}
  },
  onLoad(e) {
    if (e.token) uni.setStorageSync('x-token', e.token)
    if (e.house) uni.setStorageSync('houseId', e.house)
    uni.setStorageSync('language', e.language)
  },
  methods: {},
}
